import React from 'react';
import { X } from 'lucide-react';
import type { ScheduleViewSettings } from '../types';

interface ScheduleSettingsProps {
  settings: ScheduleViewSettings;
  onSettingsChange: (settings: ScheduleViewSettings) => void;
  onClose: () => void;
}

const DAYS = [
  { value: 0, label: '일' },
  { value: 1, label: '월' },
  { value: 2, label: '화' },
  { value: 3, label: '수' },
  { value: 4, label: '목' },
  { value: 5, label: '금' },
  { value: 6, label: '토' }
];

const ScheduleSettings: React.FC<ScheduleSettingsProps> = ({ settings, onSettingsChange, onClose }) => {
  const handleDayToggle = (day: number) => {
    const newDays = settings.visibleDays.includes(day)
      ? settings.visibleDays.filter(d => d !== day)
      : [...settings.visibleDays, day].sort();
    
    onSettingsChange({
      ...settings,
      visibleDays: newDays
    });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
        >
          <X size={24} />
        </button>

        <h2 className="text-2xl font-bold mb-6">스케줄 설정</h2>
        
        <div className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              운영 시간
            </label>
            <div className="flex items-center gap-2">
              <select
                value={settings.startHour}
                onChange={(e) => onSettingsChange({
                  ...settings,
                  startHour: parseInt(e.target.value)
                })}
                className="rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
              >
                {Array.from({ length: 24 }, (_, i) => (
                  <option key={i} value={i}>{i}:00</option>
                ))}
              </select>
              <span>부터</span>
              <select
                value={settings.endHour}
                onChange={(e) => onSettingsChange({
                  ...settings,
                  endHour: parseInt(e.target.value)
                })}
                className="rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
              >
                {Array.from({ length: 24 }, (_, i) => (
                  <option key={i} value={i}>{i}:00</option>
                ))}
              </select>
              <span>까지</span>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              표시할 요일
            </label>
            <div className="flex gap-2 flex-wrap">
              {DAYS.map(day => (
                <button
                  key={day.value}
                  onClick={() => handleDayToggle(day.value)}
                  className={`px-3 py-1 rounded-md ${
                    settings.visibleDays.includes(day.value)
                      ? 'bg-blue-600 text-white'
                      : 'bg-gray-100 text-gray-700'
                  }`}
                >
                  {day.label}
                </button>
              ))}
            </div>
          </div>

          <div className="flex justify-end">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
            >
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleSettings;